import { fg } from '@atlassian/jira-feature-gating';

const JiraPlaybookChecklistStepRelayProvider = {
	get(): boolean {
		return fg('phantom-5483-checklist-step');
	},
};

export default JiraPlaybookChecklistStepRelayProvider;
